function CustomCheckBox({ uniqueId, onChange, checked }) {
  return (
    <div className="checkboxContainer">
      <div className="checkbox-wrapper-23">
        <input
          type="checkbox"
          id={uniqueId}
          onChange={onChange}
          checked={checked}
        />
        <label htmlFor={uniqueId}>
          <svg viewBox="0,0,50,50">
            <path d="M5 30 L 20 45 L 45 5" />
          </svg>
        </label>
      </div>
    </div>
  );
}

export default CustomCheckBox;
